<mat-form-field class="relative input-wrapper-default"
                [ngClass]="inputClass"
                appearance="outline"
                [hideRequiredMarker]="true"
                floatLabel="always"
                [class.mat-form-field-invalid]="ctrl?.invalid && ctrl?.touched"
                [class.mb-1]="ctrl?.invalid && ctrl?.touched"
                [class.mb-0]="!shouldShowErrorMessage">
  <mat-label [hidden]="hideLabel">
    <span>{{inputLabel}}</span>
    <span *ngIf="isRequired" class="color-error">*</span>:
  </mat-label>
  <input *ngIf="!numeric; else numericInput" matInput
         [placeholder]="placeholder"
         [type]="inputType"
         [formControl]="ctrl.control"
         class="app-input"
         [maxlength]="maxLength"
         [required]="useRequiredProperty ? isRequired : false"
         [readonly]="readonly"
         [errorStateMatcher]="errorMatcher()"
         [attr.data-test-id]="'input_'+testId">
  <ng-template #numericInput>
    <input matInput
           [placeholder]="placeholder"
           [type]="inputType"
           [formControl]="ctrl.control"
           class="app-input"
           [maxlength]="maxLength"
           appAutonumeric
           [options]="currencyControlOptions"
           [required]="useRequiredProperty ? isRequired : false"
           [readonly]="readonly"
           [errorStateMatcher]="errorMatcher()"
           [attr.data-test-id]="'input_'+testId"
           [autonumericUpdateTriggerEventType]="autonumericUpdateTriggerEventType">
  </ng-template>
  <span *ngIf="inputType === 'search'"
        aria-hidden="true"
        class="icon icon-group color-gray-darker" matSuffix></span>
  <mat-hint *ngIf="inputHint && !isWarningVisible" class="hint" [ngClass]="inputHintClass">
    <span *ngIf="inputHintIcon" class="icon icon-info"></span> <span [innerHTML]="inputHint"></span></mat-hint>

  <mat-hint *ngIf="isWarningVisible" class="color-warning d-flex ai-center">
    <span class="icon icon-error icon-fs-md mr-q"></span>
    <span class="fs-sm">{{warningMessage}}</span>
  </mat-hint>

  <mat-error *ngIf="shouldShowErrorMessage && ctrl?.invalid && ctrl?.touched">
    <span class="icon icon-error fs-md"></span> {{getErrorMessage()}}</mat-error>
  <ng-content></ng-content>
</mat-form-field>
